import dayjs from 'dayjs'
import { useMemo } from 'react'
import { useCalendarItem } from 'screens/Calendar/FullScreenPreview/useCalendarItem'
import { CalendarFilters } from 'screens/Calendar/types'
import { StatusTag } from 'screens/FinderV2/components/List/ListRow'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

export const CalendarItemStatusTag = ({ almanacFileId, postAt }: { almanacFileId: string; postAt?: string }) => {
  const filters = useMemo<CalendarFilters>(() => ({}), [])
  const startDate = postAt ?? ''
  const workspace = useCurrentWorkspace()

  const { data: calendarItemResponse, isLoading: isCalendarItemLoading } = useCalendarItem(
    {
      id: almanacFileId,
      filters,
      startDate,
    },
    {
      enabled: !!almanacFileId,
    },
  )

  if (isCalendarItemLoading) return null

  const almanacFile = calendarItemResponse?.almanac_file
  const filePostAt = almanacFile?.post_at
  const pauseAt = workspace?.pause_autopilot_publish_at

  if (pauseAt && filePostAt && dayjs(filePostAt).isAfter(dayjs(pauseAt))) {
    return <StatusTag status="Paused" />
  }

  return <StatusTag status={almanacFile?.status ?? undefined} />
}
